import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setSubjectsReferredCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getSubjectsReferredCount() {
            return HTTP.get('/kenya/subjects_referred/get_count');
        }
    },
}